import { useLocation } from "wouter";
import { usePlatformSeo } from "@/lib/usePlatformSeo";

interface Props {
  enabled: boolean;
}

export function PlatformSeoManager({ enabled }: Props) {
  const [location] = useLocation();
  const path = (location || "/").split("?")[0].split("#")[0] || "/";
  usePlatformSeo(path, enabled);
  return null;
}

export default PlatformSeoManager;
